import { PurchaseOrderExportPeachAndLilyContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const PurchaseOrderExportPeachAndLilyPage = () => {
  return (
    <PageFrame>
      <PurchaseOrderExportPeachAndLilyContainer />
    </PageFrame>
  );
};
